import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { doc, deleteDoc, updateDoc, collection, onSnapshot, addDoc, writeBatch } from "firebase/firestore";

const AdminPanel = ({ 
  playlist, 
  displayPlaylist,  // <--- NEU
  currentIndex,     // <--- NEU
  setCurrentIndex,  // <--- NEU
  handleUserShare,  // <--- NEU
  newVideo, 
  setNewVideo, 
  addVideo, 
  moveVideo, 
  onClose, 
  onLogout 
}) => {
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({ title: "", url: "", category: "all" });
  const [categories, setCategories] = useState([]);
  const [newCatName, setNewCatName] = useState("");
  
  const [batchMode, setBatchMode] = useState(false);
  const [targetCategory, setTargetCategory] = useState("");
  const [selectedVideoIds, setSelectedVideoIds] = useState([]);

  const toggleSelectAll = () => {
    if (selectedVideoIds.length === playlist.length) {
      setSelectedVideoIds([]); 
    } else {
      setSelectedVideoIds(playlist.map(v => v.id)); 
    }
  };

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "categories"), (snap) => {
      setCategories(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return unsub;
  }, []);

  const handleAddCategory = async () => {
    if (!newCatName.trim()) return;
    try {
      await addDoc(collection(db, "categories"), { name: newCatName.trim() });
      setNewCatName("");
      console.log("Kategorie gespeichert!");
    } catch (e) {
      console.error("Fehler beim Speichern:", e);
      alert("Fehler: " + e.message);
    }
  };

  const deleteCategory = async (id) => {
    if (window.confirm("Kategorie wirklich löschen?")) {
      await deleteDoc(doc(db, "categories", id));
    }
  };

  const applyBatchUpdate = async () => {
    if (!targetCategory || selectedVideoIds.length === 0) return;
    const batch = writeBatch(db);
    selectedVideoIds.forEach(id => {
      const ref = doc(db, "videos", id);
      batch.update(ref, { category: targetCategory });
    });
    await batch.commit();
    setBatchMode(false);
    setSelectedVideoIds([]);
    alert(`${selectedVideoIds.length} Videos zu ${targetCategory} verschoben.`);
  };

  const toggleSelection = (id) => {
    setSelectedVideoIds(prev => 
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  const deleteVideo = async (id) => {
    if (window.confirm("Dieses Video wirklich unwiderruflich löschen?")) {
      try {
        await deleteDoc(doc(db, "videos", id));
        setEditingId(null);
      } catch (e) {
        console.error("Löschfehler:", e);
      }
    }
  };

  const saveEdit = async (id) => {
    await updateDoc(doc(db, "videos", id), { ...editData });
    setEditingId(null);
  };

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <h2 className="brand-name" style={{ color: "var(--streetwise-cyan)", fontSize: "0.9rem" }}>STREETWISE TV ADMIN</h2>
        <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '1.8rem' }}>&times;</button>
      </div>

      <div className="admin-content">
        <button onClick={onLogout} style={{ marginBottom: "20px", background: "none", border: "1px solid var(--streetwise-red)", color: "var(--streetwise-red)", padding: "5px 10px", fontSize: "0.7rem" }}>LOGOUT</button>

        {/* 1. UPLOAD SECTION (Jetzt ganz oben) */}
        {!batchMode && (
          <div style={{ marginBottom: "25px", padding: "15px", background: "rgba(255,255,255,0.02)", borderRadius: "10px", border: "1px solid #222" }}>
            <label style={{ fontSize: "0.6rem", color: "var(--streetwise-cyan)", display: "block", marginBottom: "10px" }}>UPLOAD NEW VIDEO:</label>
            <input className="admin-input-full" placeholder="Title" value={newVideo.title} onChange={(e) => setNewVideo({ ...newVideo, title: e.target.value })} />
            <input className="admin-input-full" placeholder="URL" value={newVideo.url} onChange={(e) => setNewVideo({ ...newVideo, url: e.target.value })} />
            <select className="admin-input-full" style={{ background: "#000", color: "#fff", height: "40px", marginBottom: "10px" }} value={newVideo.category || "all"} onChange={(e) => setNewVideo({ ...newVideo, category: e.target.value })}>
              <option value="all">all (Default)</option>
              {categories.map(cat => <option key={cat.id} value={cat.name}>{cat.name}</option>)}
            </select>
            <button className="admin-btn-add-full" onClick={addVideo}>UPLOAD VIDEO</button>
          </div>
        )}

        {/* 2. KATEGORIEN MANAGER (Darunter mit Abstand) */}
        <div style={{ marginBottom: "25px", padding: "15px", background: "rgba(255,255,255,0.03)", borderRadius: "10px", border: "1px solid #222" }}>
          <label style={{ fontSize: "0.6rem", color: "var(--streetwise-cyan)" }}>MANAGE CHANNELS (CATEGORIES):</label>
          <div style={{ display: "flex", gap: "5px", margin: "10px 0" }}>
            <input className="admin-input-full" style={{ margin: 0 }} placeholder="New Channel Name..." value={newCatName} onChange={e => setNewCatName(e.target.value)} />
            <button onClick={handleAddCategory} style={{ background: "var(--streetwise-cyan)", border: "none", padding: "0 15px", borderRadius: "4px", color: "#000", fontWeight: "bold" }}>+</button>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
            {categories.map(cat => (
              <span key={cat.id} style={{ fontSize: "0.6rem", background: "#111", padding: "4px 8px", borderRadius: "4px", border: "1px solid #333" }}>
                {cat.name} <b onClick={() => deleteCategory(cat.id)} style={{ color: "var(--streetwise-red)", cursor: "pointer", marginLeft: "5px" }}>&times;</b>
              </span>
            ))}
          </div>
        </div>

        {/* 3. BATCH EDIT BEREICH */}
        <div style={{ marginBottom: "20px", padding: "15px", background: batchMode ? "rgba(0,172,193,0.1)" : "rgba(255,255,255,0.02)", borderRadius: "10px", border: batchMode ? "1px solid var(--streetwise-cyan)" : "1px solid #222" }}>
          <button onClick={() => setBatchMode(!batchMode)} style={{ width: "100%", background: "none", border: "1px solid #444", color: "#fff", padding: "8px", fontSize: "0.7rem", cursor: "pointer", fontWeight: "bold" }}>
            {batchMode ? "CANCEL BATCH MODE" : "ENABLE BATCH ASSIGNMENT"}
          </button>
          
          {batchMode && (
            <div style={{ marginTop: "15px" }}>
              <button onClick={toggleSelectAll} style={{ width: "100%", background: "#1a1a1a", color: "#fff", border: "1px solid #333", padding: "6px", fontSize: "0.6rem", marginBottom: "10px", cursor: "pointer", fontWeight: "bold" }}>
                {selectedVideoIds.length === playlist.length ? "UNSELECT ALL" : "SELECT ALL VIDEOS"}
              </button>
              <select className="admin-input-full" onChange={(e) => setTargetCategory(e.target.value)} style={{ background: "#000", color: "#fff", marginBottom: "10px" }}>
                <option value="">Move selected to channel...</option>
                {categories.map(cat => <option key={cat.id} value={cat.name}>{cat.name}</option>)}
              </select>
              <button onClick={applyBatchUpdate} disabled={selectedVideoIds.length === 0 || !targetCategory} style={{ width: "100%", padding: "10px", background: "var(--streetwise-cyan)", color: "#000", border: "none", fontWeight: "bold", opacity: (selectedVideoIds.length > 0 && targetCategory) ? 1 : 0.5 }}>
                APPLY TO {selectedVideoIds.length} VIDEOS
              </button>
            </div>
          )}
        </div>

       {/* 4. LISTE */}
       <div className="admin-list">
          {[...playlist].sort((a, b) => (a.order || 0) - (b.order || 0)).map((video, index) => (
            <div key={video.id} className="video-item" style={{ display: "flex", alignItems: "center", padding: "12px", borderBottom: "1px solid #222" }}>
              {batchMode && (
                <input 
                  type="checkbox" 
                  checked={selectedVideoIds.includes(video.id)} 
                  onChange={() => toggleSelection(video.id)} 
                  style={{ marginRight: "15px", width: "20px", height: "20px", accentColor: "var(--streetwise-cyan)" }} 
                />
              )}

              {editingId === video.id ? (
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "10px" }}>
                  <input 
                    style={{ background: "#000", border: "1px solid #444", color: "white", padding: "8px" }} 
                    value={editData.title} 
                    onChange={(e) => setEditData({ ...editData, title: e.target.value })} 
                  />
                  <select 
                    style={{ background: "#000", border: "1px solid #444", color: "white", padding: "8px" }} 
                    value={editData.category} 
                    onChange={(e) => setEditData({ ...editData, category: e.target.value })}
                  >
                    <option value="all">all</option>
                    {categories.map(cat => <option key={cat.id} value={cat.name}>{cat.name}</option>)}
                  </select>
                  <div style={{ display: "flex", gap: "5px" }}>
                    <button onClick={() => saveEdit(video.id)} style={{ flex: 1, background: "var(--streetwise-cyan)", color: "#000", border: "none", padding: "5px" }}>SAVE</button>
                    <button onClick={() => setEditingId(null)} style={{ flex: 1, background: "#333", color: "#fff", border: "none" }}>CANCEL</button>
                    <button onClick={() => deleteVideo(video.id)} style={{ background: "none", border: "1px solid var(--streetwise-red)", color: "var(--streetwise-red)", padding: "5px 10px", fontSize: "0.8rem" }}>🗑️</button>
                  </div>
                </div>
              ) : (
                <>
                  <div 
                    style={{ flex: 1, cursor: "pointer" }} 
                    onClick={() => {
                      const videoIndex = displayPlaylist.findIndex(v => v.id === video.id);
                      if (videoIndex !== -1) {
                        setCurrentIndex(videoIndex);
                        onClose();
                      }
                    }}
                  >
                    <div className="admin-title-hover" style={{ fontSize: "0.8rem", color: "#fff" }}>{video.title}</div>
                    <div style={{ fontSize: "0.6rem", color: "var(--streetwise-cyan)" }}>[{video.category || "all"}]</div>
                  </div>

                  {!batchMode && (
                    <div style={{ display: "flex", gap: "5px" }}>
                      <button 
                        onClick={(e) => { e.stopPropagation(); handleUserShare(video); }} 
                        className="admin-nav-btn" 
                        style={{ background: "rgba(0, 242, 255, 0.1)", color: "var(--streetwise-cyan)", border: "1px solid var(--streetwise-cyan)" }}
                      >🔗</button>
                      <button onClick={() => moveVideo(index, "up")} className="admin-nav-btn">▲</button>
                      <button onClick={() => moveVideo(index, "down")} className="admin-nav-btn">▼</button>
                      <button onClick={() => { 
                        setEditingId(video.id); 
                        setEditData({ title: video.title, url: video.url, category: video.category || "all" }); 
                      }} className="admin-edit-btn">⚙️</button>
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;